import React, { useEffect, useCallback, useRef } from 'react';
import { useSelector } from 'react-redux';
import IndexSlider from '../components/SliderTickers/IndexSlider';
import ParametersForm from '../components/ParametersForm';
import ParametersSummary from '../components/ParametersSummary';
import ValidationMessages from '../components/ValidationMessages';
import styles from './ParametersContent.module.scss';

import './ParametersContent.scss';

export const RETURN_TYPE_MAPPING_NAME_EDITION = {
  'Price Total Return': 'Total Return',
  'Price Return': 'Price Return',
  'Price Net Return': 'Net Return',
};

const ParametersContent = ({
  setBasketsWithoutCoverage,
  shouldSendLaunchDate,
  setShouldSendLaunchDate,
  isSubmitBasket,
  sliderBaskets,
  setWithholdingTaxTemplateData,
  withholdingTaxTemplateData,
  existsCashConstituentsInMetadata,
  selectedBasketsData,
  selectedIndex,
  setSelectedIndex,
  handleUpdateProperty,
  errors,
  validateFields,
  enableDivisorOrStartingValue,
  setEnableDivisorOrStartingValue,
  calculationZoneOptions,
  calculationZoneMap,
}) => {
  const user = useSelector(state => state.auth);
  const authOrgPrefix = user?.org_prefix;
  const isMountedRef = useRef(true);

  const handleParameter = useCallback(
    (property, value, callback) => {
      if (!isMountedRef.current) return;

      const currentIndex = selectedIndex;

      handleUpdateProperty(prevListBasket => {
        if (!isMountedRef.current) return prevListBasket;
        return prevListBasket.map(basket =>
          basket.symbol === currentIndex ? { ...basket, [property]: value } : basket,
        );
      });
    },
    [selectedIndex, handleUpdateProperty],
  );

  useEffect(() => {
    isMountedRef.current = true;
    return () => {
      isMountedRef.current = false;
    };
  }, []);

  return (
    <div className={styles.parametersContentWrapper} key={selectedIndex}>
      <div className={styles.parametersTabContainer}>
        <div className={styles.parametersIndexSliderContainer}>
          <IndexSlider
            indexes={sliderBaskets ?? []}
            selectedIndex={selectedIndex}
            setSelectedIndex={setSelectedIndex}
          />
        </div>

        <div className={styles.parametersSectionTitle}>GENERAL PARAMETERS</div>
        <div className={styles.parametersMainPageContainer}>
          <ParametersForm
            setBasketsWithoutCoverage={setBasketsWithoutCoverage}
            selectedBasketsData={selectedBasketsData}
            shouldSendLaunchDate={shouldSendLaunchDate}
            setSelectedIndex={setSelectedIndex}
            authOrgPrefix={authOrgPrefix}
            isSubmitBasket={isSubmitBasket}
            setWithholdingTaxTemplateData={setWithholdingTaxTemplateData}
            withholdingTaxTemplateData={withholdingTaxTemplateData}
            existsCashConstituentsInMetadata={existsCashConstituentsInMetadata}
            errors={errors}
            validateFields={validateFields}
            indexMetadata={
              selectedBasketsData.find(ticker => ticker.symbol === selectedIndex) || {}
            }
            setIndexMetadata={(property, value) => handleParameter(property, value)}
            enableDivisorOrStartingValue={enableDivisorOrStartingValue}
            setEnableDivisorOrStartingValue={setEnableDivisorOrStartingValue}
            calculationZoneOptions={calculationZoneOptions}
            calculationZoneMap={calculationZoneMap}
          />
          <div className={styles.parametersRightContainer}>
            <div className={styles.parametersSummaryRightContainer}>
              <ParametersSummary
                authOrgPrefix={authOrgPrefix}
                indexMetadata={
                  selectedBasketsData.find(ticker => ticker.symbol === selectedIndex) || {}
                }
                calculationZoneMap={calculationZoneMap}
              />
            </div>
            <div className={styles.parametersValidationMessagesContainer}>
              <ValidationMessages
                setShouldSendLaunchDate={setShouldSendLaunchDate}
                indexMetadata={
                  selectedBasketsData.find(ticker => ticker.symbol === selectedIndex) || {}
                }
                enableDivisorOrStartingValue={enableDivisorOrStartingValue}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ParametersContent;
